module.exports = __webpack_public_path__ + "static/media/experience-beautiful-locations.d989ee99.jpg";